import { Component } from 'react'
import PropTypes from 'prop-types'

class Select extends Component {
    state = { focused: false }
    
    onFocus = () => {
        this.setState({ focused: true })
        if (this.props.onFocus)
            this.props.onFocus()
    }
    onBlur = () => {
        this.setState({ focused: false })
        if (this.props.onBlur)
            this.props.onBlur()
    }

    render() {
        const { placeholder, nullable, label, disabled, value, options, onFocus, onBlur, required, ...remainingProps } = this.props

        const optionsObj = Array.isArray(options) ?
            options.reduce((acc, op) => ({ ...acc, [op]: op }), {}) :
            options

        let className = 'select'
        if (placeholder || this.state.focused || value)
            className += ' select--label-raised'
        if (this.state.focused)
            className += ' select--focused'
        if (disabled)
            className += ' select--disabled'

        return (
            <label className={className}>
                <span className="select__span">{label + (required ? '*' : '')}</span>
                <select
                    value={value}
                    disabled={disabled}
                    required={required}
                    {...remainingProps}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}>
                        <option value="" disabled={!nullable}>{placeholder || ''}</option>
                        { Object.keys(optionsObj)
                                .sort((a, b) => (isNaN(a) || isNaN(b)) ? a.localeCompare(b) : a - b)
                                .map((op, i) =>
                                    <option key={`select-option--${label}-${i}`} value={op}>{optionsObj[op]}</option>) }
                </select>
            </label>
        )
    }
}

Select.propTypes = {
    label: PropTypes.string.isRequired,
    options: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]).isRequired,
    nullable: PropTypes.bool
}

export default Select